module.exports = __webpack_public_path__ + "static/media/earthsea.a5d9f692.jpg";